import { NavigationEnd, NavigationError, Router } from '@angular/router'

type StartupWindow = Window & { AuromedBoot?: { ready(): void; fail(code: string): void } }

export function reportStartupFailure(document: Document, code = 'INICIO'): void {
  try { (document.defaultView as StartupWindow | null)?.AuromedBoot?.fail(code) }
  catch { /* The independent HTML fallback remains available. */ }
}

export function monitorApplicationStartup(router: Router, document: Document): void {
  const window = document.defaultView as StartupWindow | null
  const rendered = () => {
    window?.requestAnimationFrame(() => {
      // Navigation success alone cannot certify a rendered routed component.
      if (!document.querySelector('main-view router-outlet')?.nextElementSibling) return
      try { window.AuromedBoot?.ready() } catch { /* Do not interrupt the application. */ }
      subscription.unsubscribe()
    })
  }
  const subscription = router.events.subscribe(event => {
    if (event instanceof NavigationEnd) rendered()
    else if (event instanceof NavigationError) reportStartupFailure(document, 'RUTA')
  })
  if (router.navigated) rendered()
}
